import SideIconLogout from '@pancakeswap/uikit/components/Svg/Icons/SideIconLogout'
import { IconWrapper, LogoutBlock, MenuItemWrapper, MenuText, SideMenuItem } from '../styled'

export default function SidebarFooter() {
  return (
    <LogoutBlock>
      <SideMenuItem $isActive={false}>
        <MenuItemWrapper>
          <IconWrapper>
            <SideIconLogout />
          </IconWrapper>
          <MenuText>Log Out</MenuText>
        </MenuItemWrapper>
      </SideMenuItem>
    </LogoutBlock>
  )
}
